
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1973"}},[_c('path',{attrs:{"data-name":"Rectangle 2702","fill":"none","d":"M0 0h24v24H0z"}}),_c('g',{attrs:{"data-name":"Group 1972","fill":"#adadad"}},[_c('path',{attrs:{"data-name":"Path 1297","d":"M12.208 16c4.062 0 8.854 4.1 9.671 5.983a4.11 4.11 0 01-.388.017H2.433c-.094 0-.178 0-.252-.007C3.191 20.052 8.146 16 12.208 16m0-2C5.17 14-4.606 24 2.433 24h19.058c7.036 0-2.244-10-9.283-10z"}}),_c('path',{attrs:{"data-name":"Path 1298","d":"M11.999 3a4 4 0 11-4 4 4 4 0 014-4m0-2a6 6 0 106 6 6 6 0 00-6-6z"}})])])])
          )
        }
      }
    